import { c as create_ssr_component, h as setContext, d as add_attribute, g as getContext, e as escape, s as spread, a as escape_attribute_value, b as escape_object, v as validate_component, i as each } from "./ssr.js";
import { twMerge } from "tailwind-merge";
import { c as compute_rest_props, s as subscribe } from "./utils.js";
import "./client.js";
import { B as Badge } from "./Badge.js";
import { C as Checkbox } from "./Checkbox.js";
import { T as Toggle } from "./Toggle.js";
import { T as Tooltip } from "./Tooltip.js";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime.js";
import "dayjs/locale/de.js";
import { C as CardLayout } from "./CardLayout.js";
import { g as globalToast } from "./toast2.js";
import "./api.js";
import { p as page } from "./stores.js";
import { I as InfoBox } from "./InfoBox.js";
import { I as IncompleteDataWarning, A as ApplyTrigger } from "./TaxAndInsurance.js";
import { H as HomeSolid } from "./HomeSolid.js";
import { M as MobilePhoneSolid } from "./MobilePhoneSolid.js";
import { C as CardLayoutSubmitButton } from "./CardLayoutSubmitButton.js";
import { A as Alert } from "./Alert.js";
import { B as Button } from "./Button.js";
import { M as Modal } from "./Modal2.js";
import { T as TrashBinSolid } from "./ModalHeader.js";
import { U as UploadSolid, E as EmployeeUploadModal } from "./EmployeeUploadModal.js";
const Timeline = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { order = "default" } = $$props;
  setContext("order", order);
  let olClasses = {
    group: "p-5 mb-4 bg-gray-50 rounded-lg border border-gray-100 dark:bg-gray-800 dark:border-gray-700",
    horizontal: "sm:flex",
    activity: "relative border-s border-gray-200 dark:border-gray-700",
    vertical: "relative border-s border-gray-200 dark:border-gray-700",
    default: "relative border-s border-gray-200 dark:border-gray-700"
  };
  if ($$props.order === void 0 && $$bindings.order && order !== void 0) $$bindings.order(order);
  return `<ol${add_attribute("class", twMerge(olClasses[order], $$props.class), 0)}>${slots.default ? slots.default({}) : ``}</ol> `;
});
const TimelineItem = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { title = "" } = $$props;
  let { date = "" } = $$props;
  let { svgClass = "w-3 h-3 text-primary-600 dark:text-primary-400" } = $$props;
  let order = "default";
  order = getContext("order");
  const liClasses = {
    default: "mb-10 ms-4",
    vertical: "mb-10 ms-6",
    horizontal: "relative mb-6 sm:mb-0",
    activity: "mb-10 ms-6",
    group: ""
  };
  const divClasses = {
    default: "absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -start-1.5 border border-white dark:border-gray-900 dark:bg-gray-700",
    vertical: "flex absolute -start-3 justify-center items-center w-6 h-6 bg-primary-200 rounded-full ring-8 ring-white dark:ring-gray-900 dark:bg-primary-900",
    horizontal: "flex items-center",
    activity: "flex absolute -start-3 justify-center items-center w-6 h-6 bg-primary-200 rounded-full ring-8 ring-white dark:ring-gray-900 dark:bg-primary-900",
    group: "p-5 mb-4 bg-gray-50 rounded-lg border border-gray-100 dark:bg-gray-800 dark:border-gray-700"
  };
  const timeClasses = {
    default: "mb-1 text-sm font-normal leading-none text-gray-400 dark:text-gray-500",
    vertical: "block mb-2 text-sm font-normal leading-none text-gray-400 dark:text-gray-500",
    horizontal: "block mb-2 text-sm font-normal leading-none text-gray-400 dark:text-gray-500",
    activity: "mb-1 text-xs font-normal text-gray-400 sm:order-last sm:mb-0",
    group: "text-lg font-semibold text-gray-900 dark:text-white"
  };
  let liCls = twMerge(liClasses[order], $$props.classLi);
  let divCls = twMerge(divClasses[order], $$props.classDiv);
  let timeCls = twMerge(timeClasses[order], $$props.classTime);
  const h3Cls = twMerge(
    order === "vertical" ? "flex items-center mb-1 text-lg font-semibold text-gray-900 dark:text-white" : "text-lg font-semibold text-gray-900 dark:text-white",
    $$props.classH3
  );
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.date === void 0 && $$bindings.date && date !== void 0) $$bindings.date(date);
  if ($$props.svgClass === void 0 && $$bindings.svgClass && svgClass !== void 0) $$bindings.svgClass(svgClass);
  return `<li${add_attribute("class", liCls, 0)}><div${add_attribute("class", divCls, 0)}></div> ${order !== "default" ? `${slots.icon ? slots.icon({}) : ` <svg aria-hidden="true"${add_attribute("class", svgClass, 0)} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"></path></svg> `}` : `${date ? `<time${add_attribute("class", timeCls, 0)}>${escape(date)}</time>` : ``}`} ${title ? `<h3${add_attribute("class", h3Cls, 0)}>${escape(title)}</h3>` : ``} ${order !== "default" ? `${date ? `<time${add_attribute("class", timeCls, 0)}>${escape(date)}</time>` : ``}` : ``} ${slots.default ? slots.default({}) : ``}</li> `;
});
const DownloadSolid = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["size", "role", "color", "withEvents", "title", "desc", "ariaLabel"]);
  const ctx = getContext("iconCtx") ?? {};
  const sizes = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8"
  };
  let { size = ctx.size || "md" } = $$props;
  let { role = ctx.role || "img" } = $$props;
  let { color = ctx.color || "currentColor" } = $$props;
  let { withEvents = ctx.withEvents || false } = $$props;
  let { title = {} } = $$props;
  let { desc = {} } = $$props;
  let ariaDescribedby = `${title.id || ""} ${desc.id || ""}`;
  let hasDescription = false;
  let { ariaLabel = "download solid" } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.role === void 0 && $$bindings.role && role !== void 0) $$bindings.role(role);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0) $$bindings.color(color);
  if ($$props.withEvents === void 0 && $$bindings.withEvents && withEvents !== void 0) $$bindings.withEvents(withEvents);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0) $$bindings.desc(desc);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0) $$bindings.ariaLabel(ariaLabel);
  {
    if (title.id || desc.id) {
      hasDescription = true;
    } else {
      hasDescription = false;
    }
  }
  return `${withEvents ? `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path fill-rule="evenodd" d="M13 11.15V4a1 1 0 1 0-2 0v7.15L8.78 8.374a1 1 0 1 0-1.56 1.25l4 5a1 1 0 0 0 1.56 0l4-5a1 1 0 1 0-1.56-1.25L13 11.15Z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M9.657 15.874 7.358 13H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2.358l-2.3 2.874a3 3 0 0 1-4.685 0ZM17 16a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H17Z" clip-rule="evenodd"></path></svg>` : `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path fill-rule="evenodd" d="M13 11.15V4a1 1 0 1 0-2 0v7.15L8.78 8.374a1 1 0 1 0-1.56 1.25l4 5a1 1 0 0 0 1.56 0l4-5a1 1 0 1 0-1.56-1.25L13 11.15Z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M9.657 15.874 7.358 13H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2.358l-2.3 2.874a3 3 0 0 1-4.685 0ZM17 16a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H17Z" clip-rule="evenodd"></path></svg>`} `;
});
const EnvelopeOpenSolid = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["size", "role", "color", "withEvents", "title", "desc", "ariaLabel"]);
  const ctx = getContext("iconCtx") ?? {};
  const sizes = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8"
  };
  let { size = ctx.size || "md" } = $$props;
  let { role = ctx.role || "img" } = $$props;
  let { color = ctx.color || "currentColor" } = $$props;
  let { withEvents = ctx.withEvents || false } = $$props;
  let { title = {} } = $$props;
  let { desc = {} } = $$props;
  let ariaDescribedby = `${title.id || ""} ${desc.id || ""}`;
  let hasDescription = false;
  let { ariaLabel = "envelope open solid" } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.role === void 0 && $$bindings.role && role !== void 0) $$bindings.role(role);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0) $$bindings.color(color);
  if ($$props.withEvents === void 0 && $$bindings.withEvents && withEvents !== void 0) $$bindings.withEvents(withEvents);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0) $$bindings.desc(desc);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0) $$bindings.ariaLabel(ariaLabel);
  {
    if (title.id || desc.id) {
      hasDescription = true;
    } else {
      hasDescription = false;
    }
  }
  return `${withEvents ? `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path d="m3.62 6.389 8.396 6.724 8.638-6.572-7.69-4.29a1.975 1.975 0 0 0-1.928 0L3.62 6.39Z"></path><path d="m22 8.053-8.784 6.683a1.978 1.978 0 0 1-2.44-.031L2.02 7.693a1.091 1.091 0 0 0-.019.199v11.065C2 20.637 3.343 22 5 22h14c1.657 0 3-1.362 3-3.043V8.053Z"></path></svg>` : `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path d="m3.62 6.389 8.396 6.724 8.638-6.572-7.69-4.29a1.975 1.975 0 0 0-1.928 0L3.62 6.39Z"></path><path d="m22 8.053-8.784 6.683a1.978 1.978 0 0 1-2.44-.031L2.02 7.693a1.091 1.091 0 0 0-.019.199v11.065C2 20.637 3.343 22 5 22h14c1.657 0 3-1.362 3-3.043V8.053Z"></path></svg>`} `;
});
const FacebookSolid = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["size", "role", "color", "withEvents", "title", "desc", "ariaLabel"]);
  const ctx = getContext("iconCtx") ?? {};
  const sizes = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8"
  };
  let { size = ctx.size || "md" } = $$props;
  let { role = ctx.role || "img" } = $$props;
  let { color = ctx.color || "currentColor" } = $$props;
  let { withEvents = ctx.withEvents || false } = $$props;
  let { title = {} } = $$props;
  let { desc = {} } = $$props;
  let ariaDescribedby = `${title.id || ""} ${desc.id || ""}`;
  let hasDescription = false;
  let { ariaLabel = "facebook solid" } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.role === void 0 && $$bindings.role && role !== void 0) $$bindings.role(role);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0) $$bindings.color(color);
  if ($$props.withEvents === void 0 && $$bindings.withEvents && withEvents !== void 0) $$bindings.withEvents(withEvents);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0) $$bindings.desc(desc);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0) $$bindings.ariaLabel(ariaLabel);
  {
    if (title.id || desc.id) {
      hasDescription = true;
    } else {
      hasDescription = false;
    }
  }
  return `${withEvents ? `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path fill-rule="evenodd" d="M13.135 6H15V3h-1.865a4.147 4.147 0 0 0-4.142 4.142V9H7v3h2v9.938h3V12h2.021l.592-3H12V6.591A.6.6 0 0 1 12.592 6h.543Z" clip-rule="evenodd"></path></svg>` : `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path fill-rule="evenodd" d="M13.135 6H15V3h-1.865a4.147 4.147 0 0 0-4.142 4.142V9H7v3h2v9.938h3V12h2.021l.592-3H12V6.591A.6.6 0 0 1 12.592 6h.543Z" clip-rule="evenodd"></path></svg>`} `;
});
const MailBoxSolid = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["size", "role", "color", "withEvents", "title", "desc", "ariaLabel"]);
  const ctx = getContext("iconCtx") ?? {};
  const sizes = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8"
  };
  let { size = ctx.size || "md" } = $$props;
  let { role = ctx.role || "img" } = $$props;
  let { color = ctx.color || "currentColor" } = $$props;
  let { withEvents = ctx.withEvents || false } = $$props;
  let { title = {} } = $$props;
  let { desc = {} } = $$props;
  let ariaDescribedby = `${title.id || ""} ${desc.id || ""}`;
  let hasDescription = false;
  let { ariaLabel = "mail box solid" } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.role === void 0 && $$bindings.role && role !== void 0) $$bindings.role(role);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0) $$bindings.color(color);
  if ($$props.withEvents === void 0 && $$bindings.withEvents && withEvents !== void 0) $$bindings.withEvents(withEvents);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0) $$bindings.desc(desc);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0) $$bindings.ariaLabel(ariaLabel);
  {
    if (title.id || desc.id) {
      hasDescription = true;
    } else {
      hasDescription = false;
    }
  }
  return `${withEvents ? `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path d="M17 6h-2V5h1a1 1 0 1 0 0-2h-2a1 1 0 0 0-1 1v2h-.541A5.965 5.965 0 0 1 14 10v4a1 1 0 1 1-2 0v-4c0-2.206-1.794-4-4-4-.075 0-.148.012-.22.028C7.686 6.022 7.596 6 7.5 6A4.505 4.505 0 0 0 3 10.5V16a1 1 0 0 0 1 1h7v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3h5a1 1 0 0 0 1-1v-6c0-2.206-1.794-4-4-4Zm-9 8.5H7a1 1 0 1 1 0-2h1a1 1 0 1 1 0 2Z"></path></svg>` : `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path d="M17 6h-2V5h1a1 1 0 1 0 0-2h-2a1 1 0 0 0-1 1v2h-.541A5.965 5.965 0 0 1 14 10v4a1 1 0 1 1-2 0v-4c0-2.206-1.794-4-4-4-.075 0-.148.012-.22.028C7.686 6.022 7.596 6 7.5 6A4.505 4.505 0 0 0 3 10.5V16a1 1 0 0 0 1 1h7v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3h5a1 1 0 0 0 1-1v-6c0-2.206-1.794-4-4-4Zm-9 8.5H7a1 1 0 1 1 0-2h1a1 1 0 1 1 0 2Z"></path></svg>`} `;
});
const Reminder = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_globalToast;
  let $employee, $$unsubscribe_employee;
  $$unsubscribe_globalToast = subscribe(globalToast, (value) => value);
  const employee = getContext("employee");
  $$unsubscribe_employee = subscribe(employee, (value) => $employee = value);
  getContext("super_edit");
  dayjs.extend(relativeTime);
  dayjs.locale("de");
  let displayDoneReminders = false;
  let displayedReminders = [];
  let display = false;
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    {
      if (displayDoneReminders) {
        displayedReminders = $employee?.reminders?.filter((reminder) => {
          return reminder.doneAt?.value;
        });
      } else {
        displayedReminders = $employee?.reminders?.filter((reminder) => {
          return !reminder.doneAt?.value;
        });
      }
    }
    $$rendered = `${validate_component(CardLayout, "CardLayout").$$render(
      $$result,
      {
        title: "Erinnerungen",
        accordion: true,
        display
      },
      {
        display: ($$value) => {
          display = $$value;
          $$settled = false;
        }
      },
      {
        "card-header": () => {
          return `<div class="flex gap-12">${display ? `${validate_component(Toggle, "Toggle").$$render(
            $$result,
            {
              class: "text-gray-500 dark:text-gray-400 w-[280px]",
              size: "small",
              checked: displayDoneReminders
            },
            {
              checked: ($$value) => {
                displayDoneReminders = $$value;
                $$settled = false;
              }
            },
            {
              default: () => {
                return `Erledigte Erinnerungen ${escape(displayDoneReminders ? "ausblenden" : "anzeigen")}`;
              }
            }
          )}` : ``} ${displayedReminders && displayedReminders.length > 0 ? `${validate_component(Badge, "Badge").$$render($$result, { color: "yellow" }, {}, {
            default: () => {
              return `${escape(displayedReminders.length)}`;
            }
          })}` : ``}</div> `;
        },
        default: () => {
          return `${displayedReminders.length ? `<ul class="list-inside ml-2 list-disc space-y-2 text-neutral-600">${each(displayedReminders || [], (reminder) => {
            return `<li class="flex flex-row gap-3">${validate_component(Checkbox, "Checkbox").$$render(
              $$result,
              {
                type: "checkbox",
                id: "reminder-" + reminder.uuid,
                checked: !!reminder.doneAt?.value,
                class: "w-4 h-4 text-blue-500 dark:text-blue-400"
              },
              {},
              {}
            )} <span class="text-sm ">${reminder.doneAt?.value ? `${escape(dayjs.unix(reminder.doneAt.stamp).fromNow())} erledigt:` : ``}</span> <div class="text-sm flex-1"><!-- HTML_TAG_START -->${reminder.note}<!-- HTML_TAG_END --></div> <span class="${"w-32 text-sm " + escape(
              dayjs.unix(reminder.remindAt.stamp).isBefore(dayjs()) ? "text-red-500" : "text-primary-700",
              true
            )}">Fällig: ${escape(dayjs.unix(reminder.remindAt.stamp).fromNow())}</span> ${validate_component(Tooltip, "Tooltip").$$render($$result, {}, {}, {
              default: () => {
                return `${escape(dayjs.unix(reminder.remindAt.stamp).format("DD.MM @ HH:mm"))}`;
              }
            })} </li>`;
          })}</ul>` : `<div class="flex flex-col space-y-2" data-svelte-h="svelte-18n5xw8"><span class="text-sm text-gray-500">Keine Erinnerungen</span></div>`}`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_globalToast();
  $$unsubscribe_employee();
  return $$rendered;
});
function addressComplete(address) {
  if (!address) {
    return false;
  }
  return !(!address.country || !address.zip || !address.number || !address.street || !address.place || !address.country);
}
const GeneralInfo = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let complete;
  let $page, $$unsubscribe_page;
  $$unsubscribe_page = subscribe(page, (value) => $page = value);
  let { employee = $page.data.employee } = $$props;
  getContext("super_edit");
  let loading = false;
  if ($$props.employee === void 0 && $$bindings.employee && employee !== void 0) $$bindings.employee(employee);
  complete = addressComplete(employee.address) && employee.mobile && employee.email;
  $$unsubscribe_page();
  return `${validate_component(CardLayout, "CardLayout").$$render($$result, { title: "Kontakt" }, {}, {
    "card-header": () => {
      return `${validate_component(IncompleteDataWarning, "IncompleteDataWarning").$$render($$result, { complete }, {}, {})} `;
    },
    default: () => {
      return `<form class="${["flex flex-col gap-3", ""].join(" ").trim()}" method="post" action="?/update_employee"><div class="flex flex-col gap-1 px-4">${validate_component(InfoBox, "InfoBox").$$render(
        $$result,
        {
          icon: MobilePhoneSolid,
          value: employee.mobile,
          name: "mobile",
          link: employee.mobile ? `tel:${employee.mobile}` : null
        },
        {},
        {}
      )} ${validate_component(InfoBox, "InfoBox").$$render(
        $$result,
        {
          icon: EnvelopeOpenSolid,
          type: "email",
          link: "mailto:" + employee.email,
          value: employee.email || "",
          name: "email"
        },
        {},
        {}
      )}</div> <div class="my-2 border-b border-dotted"></div> <div class="flex flex-col gap-1 px-4">${validate_component(InfoBox, "InfoBox").$$render(
        $$result,
        {
          link: "https://www.facebook.com",
          icon: FacebookSolid,
          value: employee.cv?.facebook || ""
        },
        {},
        {}
      )} ${validate_component(InfoBox, "InfoBox").$$render(
        $$result,
        {
          link: "https://www.instagram.com",
          icon: "ri:instagram-fill",
          value: employee.cv?.instagram || ""
        },
        {},
        {}
      )}</div> <div class="my-2 border-b border-dotted"></div> <div class="flex flex-col gap-1 px-4 ">${validate_component(InfoBox, "InfoBox").$$render(
        $$result,
        {
          icon: HomeSolid,
          value: employee.address?.name || "",
          placeholder: "Name d. Adresse",
          name: "address_name"
        },
        {},
        {}
      )} ${validate_component(InfoBox, "InfoBox").$$render(
        $$result,
        {
          icon: MailBoxSolid,
          value: employee.address?.addressAddendum || "",
          placeholder: "Adresszusatz",
          name: "address_addressAddendum"
        },
        {},
        {}
      )} <div class="flex gap-x-2">${validate_component(InfoBox, "InfoBox").$$render(
        $$result,
        {
          class: "pl-7",
          value: employee.address?.street || "",
          placeholder: "Straße",
          name: "address_street"
        },
        {},
        {}
      )} <div class="flex-1">${validate_component(InfoBox, "InfoBox").$$render(
        $$result,
        {
          displayClass: "!pl-1",
          value: employee.address?.number || "",
          placeholder: "Hausnummer",
          name: "address_number"
        },
        {},
        {}
      )}</div></div> <div class="grid grid-cols-3 gap-x-2 ">${validate_component(InfoBox, "InfoBox").$$render(
        $$result,
        {
          class: "pl-7",
          value: employee.address?.zip || "",
          placeholder: "PLZ",
          name: "address_zip"
        },
        {},
        {}
      )} <div class="col-span-2">${validate_component(InfoBox, "InfoBox").$$render(
        $$result,
        {
          displayClass: "!pl-1",
          value: employee.address?.place || "",
          placeholder: "Ort",
          name: "address_place"
        },
        {},
        {}
      )}</div></div> ${validate_component(InfoBox, "InfoBox").$$render(
        $$result,
        {
          class: "pl-7",
          value: employee.address?.country || "",
          placeholder: "Land",
          name: "address_country"
        },
        {},
        {}
      )} ${validate_component(CardLayoutSubmitButton, "CardLayoutSubmitButton").$$render($$result, {}, {}, {})} ${validate_component(ApplyTrigger, "ApplyTrigger").$$render($$result, { loading }, {}, {})}</div> ${employee.address ? `<div class="flex flex-col gap-2 px-4 py-2"><iframe title="Map" class="col-span-2" width="100%" height="100%" id="gmap_canvas"${add_attribute("src", `https://maps.google.com/maps?q=${employee.address.street.replace(/\s/, "%20")}%20${employee.address.number}%20${employee.address.place}%20${employee.address.country}&t=&z=15&ie=UTF8&iwloc=&output=embed`, 0)} frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe></div>` : ``}</form>`;
    }
  })}`;
});
const Photos = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $page, $$unsubscribe_page;
  $$unsubscribe_page = subscribe(page, (value) => $page = value);
  let { employee = $page.data.employee } = $$props;
  let selectedImage = null;
  let imageModal = false;
  let photoUploadModal = false;
  if ($$props.employee === void 0 && $$bindings.employee && employee !== void 0) $$bindings.employee(employee);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(CardLayout, "CardLayout").$$render(
      $$result,
      {
        title: "Fotos",
        className: "sticky top-24"
      },
      {},
      {
        "card-header": () => {
          return `<div slot="card-header" class="relative"><div class="absolute right-0 w-36 grid place-items-end">${validate_component(Button, "Button").$$render($$result, { size: "xs", class: "mt-1" }, {}, {
            default: () => {
              return `${validate_component(UploadSolid, "UploadSolid").$$render($$result, { class: "w-3 h-3 mr-2" }, {}, {})}Foto hochladen`;
            }
          })}</div></div>`;
        },
        default: () => {
          return `<div class="grid place-items-center gap-2">${employee.avatarFile ? `<div role="button" tabindex="0" class="relative w-1/2 rounded border cursor-pointer hover:border-primary-400"><img class="w-full"${add_attribute("src", employee.avatarFile, 0)} alt="Profile-Picture"></div>` : ``} ${each(employee.images.filter((x) => !x.location.toLowerCase().includes(".pdf")), (image) => {
            return `<div role="button" tabindex="0" class="relative w-1/2 rounded border cursor-pointer hover:border-primary-400"><img class="w-full"${add_attribute("src", image.location, 0)}${add_attribute("alt", image.location, 0)}> </div>`;
          })}</div>`;
        }
      }
    )} ${validate_component(EmployeeUploadModal, "EmployeeUploadModal").$$render(
      $$result,
      { open: photoUploadModal, employee },
      {
        open: ($$value) => {
          photoUploadModal = $$value;
          $$settled = false;
        },
        employee: ($$value) => {
          employee = $$value;
          $$settled = false;
        }
      },
      {}
    )} ${validate_component(Modal, "Modal").$$render(
      $$result,
      {
        title: selectedImage?.imageTag?.toUpperCase(),
        open: imageModal
      },
      {
        open: ($$value) => {
          imageModal = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `<img class="w-full"${add_attribute("src", selectedImage.location, 0)}${add_attribute("alt", selectedImage.location, 0)}> ${selectedImage.documentNumber ? `<p>Number: ${escape(selectedImage.documentNumber)}</p>` : ``} ${selectedImage.blockInteraction ? `${validate_component(Alert, "Alert").$$render($$result, { color: "yellow" }, {}, {
            default: () => {
              return `<p data-svelte-h="svelte-pzelqe">Profilbilder müssen über &quot;Bearbeiten&quot; -&gt; Avatar geändert werden.</p>`;
            }
          })}` : `<div class="flex justify-between">${validate_component(Button, "Button").$$render($$result, { href: selectedImage.location }, {}, {
            default: () => {
              return `${validate_component(DownloadSolid, "DownloadSolid").$$render($$result, { class: "w-3 h-3 mr-2" }, {}, {})} <span data-svelte-h="svelte-q9mf3e">Download</span>`;
            }
          })} ${validate_component(Button, "Button").$$render($$result, { color: "red" }, {}, {
            default: () => {
              return `${validate_component(TrashBinSolid, "TrashBinSolid").$$render($$result, { class: "w-3 h-3 mr-2" }, {}, {})} <span data-svelte-h="svelte-rzi7zr">Löschen</span>`;
            }
          })}</div>`}`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_page();
  return $$rendered;
});
export {
  GeneralInfo as G,
  Photos as P,
  Reminder as R,
  Timeline as T,
  TimelineItem as a
};
//# sourceMappingURL=Photos.js.map
